// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"ba4e66b1","342":"bb62299f","463":"fe09272a","787":"d0aae870","988":"5a2cc67c"}[chunkId] + ".chunk.js";
};